import React, { useState, useEffect } from "react";
import { Btn, FlexDiv } from "../../assets/styles/style";
import { NavText } from "./style";
import { useNavigate, useLocation } from "react-router-dom";

const IeltsNavTabs = () => {
  const [activeTab, setActiveTab] = useState("dashboard"); // "dashboard" or "results"
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Set the active tab based on the current URL
    if (location.pathname === "/ielts-dashboard") {
      setActiveTab("dashboard");
    } else if (location.pathname === "/ielts-results" || location.pathname.includes("/ielts-test-details")) {
      setActiveTab("results");
    }
  }, [location.pathname]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "dashboard") {
      navigate("/ielts-dashboard");
    } else if (tab === "results") {
      navigate("/ielts-results");
    }
  };

  return (
    <>
      <Btn 
        onClick={() => handleTabClick("dashboard")}
        style={{ width: "100%" }}
      >
        <NavText style={{ color: activeTab === "dashboard" ? "#6B41CB" : "" }}>
          Dashboard
        </NavText>
      </Btn>
      <Btn 
        onClick={() => handleTabClick("results")}
        style={{ width: "100%" }}
      >
        <NavText style={{ color: activeTab === "results" ? "#6B41CB" : "" }}>
          Results
        </NavText>
      </Btn>
    </>
  );
};

export default IeltsNavTabs; 